<template>
  <div class="u-wrapper-panel">

    <promise-letters
      @ending="onEnding"
      v-if="data.typeHandle === 'brightPromiseInteractif'"
      @ready="isReady = true"
    /> 
    <video-scroll
      @ending="onEnding"
      @ready="isReady = true"
      v-else-if="data.brightPromiseVideos"
      :videoSRC="data.brightPromiseVideos[0].url"
      :videoInverseSRC="data.brightPromiseVideos[1].url"
    /> 

    <case-study-preview
      ref="caseStudy"
      v-show="isEnding"
      v-if="data.brightCaseStudy"
      :style="{transform: `translateY(${caseTransform}px) translateZ(0)`}"
      :data="data.brightCaseStudy[0]"
    />

    <div
      v-if="scrollValue <= $device.height"
      class="u-wrapper-panel u-flex u-center u-middle u-overflow-hidden u-z-middle"
      :style="{
        backgroundColor: data.color,
        transform: `translateY(${-scrollValue}px) translateZ(0)`
      }"
    >
      <p v-if="data.promiseTitle" class="u-white t-h3 u-pad-x-1of12 u-full-width u-white-space" :style="{transform: `translateY(${scrollValue * .25}px) translateZ(0)`}">
        {{data.promiseTitle}}
      </p>
    </div>
  </div>
</template>

<script>

import VideoScroll from '@/components/VideoScroll'
import PromiseLetters from '@/components/PromiseLetters'
import CaseStudyPreview from '@/components/CaseStudyPreview'
import { VirtualScroll } from '@/utils/VirtualScroll'

export default {
  metaInfo () {
    return {
      link: [
        { rel: 'canonical', href: 'https://brig.ht/promise/' + this.$route.params.slug }
      ]
    }
  },
  components: {
    VideoScroll,
    CaseStudyPreview,
    PromiseLetters
  },

  data() {
    return {
      scrollValue: 0,
      startEnding: 0,
      caseTransform: 100000,
      isEnding: false,
      isReady: false
    }
  },

  computed: {
    data () {
      return this.$store.getters['data/promiseBySlug'](this.$route.params.slug)
    },
    contact () {
      return this.$store.getters['data/contact'][0]
    }
  },

  created () {
    this.caseHeight = 0
    this.delta = 0
    this.isNext = false
    this.onRouteChange()

    this.virtualScroll = new VirtualScroll({ clamp: { min: 0 } })
    this.virtualScroll.onSmoothScroll(this.onSmoothScroll)
    this.virtualScroll.isActive = this.isReady
  },

  methods: {
    onSmoothScroll ({ value }) {
      this.scrollValue = value

      if (this.isEnding) {
        this.caseTransform = -(this.scrollValue - (this.startEnding + this.$device.height))

        this.caseTransform = this.caseTransform <= this.delta ? this.delta : this.caseTransform
      }

      if (!this.isNext && this.isEnding && this.caseHeight && this.scrollValue - this.startEnding >= this.caseHeight) {
        this.isNext = true

        if (this.data.next) {
          this.$router.push({...this.$local('Promise'), params: {slug: this.data.next.slug }})
        }
        else {
          if (this.$device.isTouch) {
            this.$router.push(this.$local('Projects'))
          }
          else {
            this.$router.push(this.$local('EndPage'))
          }
        }
      }
    },

    onEnding (value) {
      this.isEnding = value
      requestAnimationFrame(this.onResize)
    },

    onResize() {
      if (this.$refs.caseStudy) {
        this.caseHeight = this.$refs.caseStudy.$el.offsetHeight
      }
      this.delta = this.$device.height - this.caseHeight
    },

    async onRouteChange () {
      if (this.data === void 0) {
        this.$router.push(this.$local('Homepage'))
      }
      else if (this.data.isFull === false) {
        await this.$store.dispatch('data/promise', this.data.slug)
      }

      this.scrollValue = 0,
      this.startEnding = 0,
      this.caseTransform = 100000,
      this.isEnding = false
      this.isNext = false
      this.isReady = false

      if (this.virtualScroll) {
        this.virtualScroll.reInit()
      }

      this.onResize()
    }
  },

  watch: {
    isReady () {
      this.virtualScroll.isActive = this.isReady
    },
    isEnding (value) {
      if (this.isEnding) {
        this.startEnding = this.scrollValue
      }
      else {
        this.startEnding = 0
      }
    },

    $route () {
      this.onRouteChange()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/variables'
</style>
